import React, {Fragment} from 'react';
import {Button, Checkbox, Col, Form, Input, Radio, Row} from 'antd';
import {GUTTER_MD, MARGIN_MD, SPAN_FULL, SPAN_HALF} from '../../../../../styles/constants';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import connect from 'react-redux/es/connect/connect';
import FileInput from '../../../../../components/file-input';
import {
  changeFileMappingWizardCsvForm,
  setFileMappingWizardCsvFormFileFormat,
  submitFileMappingWizardCsvForm
} from './actions';
import {showFileMappingWizardCsvRowList} from "../csv-row-list/actions";
import {convertFileMappingWizardPxToCsv, convertFileMappingWizardXlsToCsv} from "../actions";
import Call from "../../../../../hocs/call";

const mapStateToProps = state => ({
  csvForm: state.scenes.dataManager.fileMapping.components.wizard.shared.csvForm,
  csvHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.csvHeader,
  fileFormat: state.scenes.dataManager.fileMapping.components.wizard.shared.fileFormat,
  fileServerPath: state.scenes.dataManager.fileMapping.components.wizard.shared.fileServerPath,
  csvServerPath: state.scenes.dataManager.fileMapping.components.wizard.shared.csvServerPath,
  xmlServerPath: state.scenes.dataManager.fileMapping.components.wizard.shared.xmlServerPath,
  cubeId: state.scenes.dataManager.fileMapping.components.wizard.shared.cubeId
});

const mapDispatchToProps = dispatch => ({
  onChange: fields => dispatch(changeFileMappingWizardCsvForm(fields)),
  onFileFormatSet: fileFormat => dispatch(setFileMappingWizardCsvFormFileFormat(fileFormat)),
  onSubmit: (file, xmlFile) => dispatch(submitFileMappingWizardCsvForm(file, xmlFile)),
  onCsvRowListShow: () => dispatch(showFileMappingWizardCsvRowList()),
  onConvertPxToCsv: ({
                       fileServerPath,
                       cubeId
                     }) => dispatch(convertFileMappingWizardPxToCsv(fileServerPath, cubeId)),
  onConvertXlsToCsv: ({
                        fileServerPath,
                        xmlServerPath,
                        cubeId
                      }) => dispatch(convertFileMappingWizardXlsToCsv(fileServerPath, xmlServerPath, cubeId)),
});

const mapPropsToFields = ({csvForm}) => ({
  file: Form.createFormField({value: csvForm.file}),
  xmlFile: Form.createFormField({value: csvForm.xmlFile}),
  separator: Form.createFormField({value: csvForm.separator}),
  delimiter: Form.createFormField({value: csvForm.delimiter}),
  hasHeader: Form.createFormField({value: csvForm.hasHeader}),
  hasDotStatFormat: Form.createFormField({value: csvForm.hasDotStatFormat})
});

// TODO: prevent multiple changes relative to same value
const onFieldsChange = (props, fields) => props.onChange(fields);

const FileMappingWizardCsvForm = ({
                                    t,
                                    form,
                                    fileFormat,
                                    csvForm,
                                    csvHeader,
                                    cubeId,
                                    fileServerPath,
                                    csvServerPath,
                                    xmlServerPath,
                                    onFileFormatSet,
                                    onConvertPxToCsv,
                                    onConvertXlsToCsv,
                                    onSubmit,
                                    onCsvRowListShow
                                  }) =>
  <Call cb={onConvertPxToCsv} cbParam={{fileServerPath, cubeId}}
        disabled={fileFormat !== 'px' || fileServerPath === null || csvServerPath !== null}>
    <Call cb={onConvertXlsToCsv} cbParam={{fileServerPath, xmlServerPath, cubeId}}
          disabled={fileFormat !== 'xls' || fileServerPath === null || xmlServerPath === null || csvServerPath !== null}>
      <Form className="advanced-form">
        <Row style={{marginBottom: MARGIN_MD}} gutter={GUTTER_MD}>
          <Col span={SPAN_FULL}>
            <Radio.Group
              defaultValue="csv"
              value={fileFormat}
              onChange={({target}) => onFileFormatSet(target.value)}
            >
              <Radio.Button value="csv">
                CSV
              </Radio.Button>
              <Radio.Button value="xls">
                Excel
              </Radio.Button>
              <Radio.Button value="px">
                PC-Axis
              </Radio.Button>
            </Radio.Group>
          </Col>
        </Row>
        <Row style={{marginBottom: MARGIN_MD}} gutter={GUTTER_MD}>
          <Col span={SPAN_FULL}>
            <Form.Item className="form-item-required" label={t('data.csv.file.label')}>
              {form.getFieldDecorator('file')(
                <FileInput
                  accept={fileFormat === "xls" ? ".xls,.xlsx" : `.${fileFormat}`}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        {fileFormat === 'csv' && (
          <Fragment>
            <Row style={{marginBottom: MARGIN_MD}} gutter={GUTTER_MD}>
              <Col span={SPAN_HALF}>
                <Form.Item className="form-item-required" label={t('data.csv.separator.label')}>
                  {form.getFieldDecorator('separator')(<Input maxLength={1}/>)}
                </Form.Item>
              </Col>
              <Col span={SPAN_HALF}>
                <Form.Item label={t('data.csv.delimiter.label')}>
                  {form.getFieldDecorator('delimiter')(<Input maxLength={1}/>)}
                </Form.Item>
              </Col>
            </Row>
            <Row style={{marginBottom: MARGIN_MD}} gutter={GUTTER_MD}>
              <Col span={SPAN_HALF}>
                <Form.Item className="form-item-required" label={t('data.csv.hasHeader.label')}>
                  {form.getFieldDecorator('hasHeader', {valuePropName: 'checked'})(<Checkbox/>)}
                </Form.Item>
              </Col>
              <Col span={SPAN_HALF}>
                <Form.Item className="form-item-required"
                           label={t('data.csv.hasDotStatFormat.label')}>
                  {form.getFieldDecorator('hasDotStatFormat', {valuePropName: 'checked'})(
                    <Checkbox/>)}
                </Form.Item>
              </Col>
            </Row>
          </Fragment>
        )}
        {fileFormat === 'xls' && (
          <Row style={{marginBottom: MARGIN_MD}} gutter={GUTTER_MD}>
            <Col span={SPAN_FULL}>
              <Form.Item className="form-item-required" label={t('data.csv.xmlFile.label')}>
                {form.getFieldDecorator('xmlFile')(<FileInput accept=".xml"/>)}
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row type="flex" gutter={GUTTER_MD}>
          <Col>
            <Button
              disabled={
                csvForm.file === null ||
                (fileFormat === 'csv' && (csvForm.separator === null || csvForm.separator.length !== 1)) ||
                (fileFormat === 'xls' && csvForm.xmlFile === null)
              }
              icon="upload"
              type="primary"
              onClick={() => onSubmit(csvForm.file, fileFormat === 'xls' ? csvForm.xmlFile : null)}
            >
              {t('data.csv.uploadButton.label')}
            </Button>
          </Col>
          <Col>
            <Button
              onClick={onCsvRowListShow}
              icon="table"
              disabled={csvHeader === null}
              style={{width: '100%'}}>
              {t('scenes.dataManager.fileMapping.wizard.csvForm.buttons.csvRowListShow')}
            </Button>
          </Col>
        </Row>
      </Form>
    </Call>
  </Call>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
)(FileMappingWizardCsvForm);



// WEBPACK FOOTER //
// ./src/scenes/data-manager/file-mapping/wizard/csv-form/index.jsx